import { render } from "./DmMenu.vue?vue&type=template&id=06a384fe"
import script from "./DmMenu.vue?vue&type=script&lang=js"
export * from "./DmMenu.vue?vue&type=script&lang=js"

import "./DmMenu.vue?vue&type=style&index=0&id=06a384fe&lang=css"

import exportComponent from "/builds/digitalmasters/team-wombat/alenus-bottle-o-ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__